var map = {
	"./AU-ANU.png": 480,
	"./AU-Melbourne.jpeg": 481,
	"./AU-Monash.png": 482,
	"./AU-NewSouthWales.png": 483,
	"./AU-SYDNEY.png": 484,
	"./AU-UQ.jpg": 485,
	"./CSU-Signature-Stacked-357-617.svg": 486,
	"./CTY-ISC-lockup-landscape-alternative-logo-fullColour-rgb.svg": 487,
	"./HK-EdUHK.jpeg": 488,
	"./HK-HKBU.png": 489,
	"./HK-HKMU.png": 490,
	"./HK-HKSYU.jpg": 491,
	"./HK-Lingnan.png": 492,
	"./HK-PolyU.png": 493,
	"./JAPAN-Keio.png": 494,
	"./JAPAN-Kyoto.png": 495,
	"./JAPAN-Nagoya.png": 496,
	"./JAPAN-OsakaU.jpg": 497,
	"./JAPAN-Waseda.png": 498,
	"./SING-Curtin.png": 499,
	"./SING-Newcastle.jpg": 500,
	"./SING-RMIT-SG.jpeg": 501,
	"./SING-RMIT-SG.png": 502,
	"./SING-UOW-SG.png": 503,
	"./SING-Ucd.png": 504,
	"./UK-Birmingham.png": 505,
	"./UK-Edinburgh.png": 506,
	"./UK-Glasgow.png": 507,
	"./UK-Lancaster.jpg": 508,
	"./UK-Leeds.png": 509,
	"./UK-London.png": 510,
	"./UK-Manchester.png": 511,
	"./UK-Sheffield.jpg": 512,
	"./USA- Ohio.jpeg": 513,
	"./USA-CWRU.jpg": 514,
	"./USA-California.jpg": 515,
	"./USA-California2.jpg": 516,
	"./USA-Pennsylvania.png": 517,
	"./USA-Purdue.png": 518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 479;